import React from 'react';

const About = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', lineHeight: '1.6' }}>
      <h1>도토리 저금통 소개</h1>

      <section style={{ marginBottom: '30px' }}>
        <h2>서비스 개요</h2>
        <p>도토리 저금통(Acorn Bank)은 가족 구성원이 함께 참여하는 미션 기반 용돈 관리 서비스입니다.
        자녀들이 일상 속 미션을 수행하고, 부모의 승인을 통해 용돈을 받을 수 있는 시스템으로
        생활습관 형성과 금융 교육을 동시에 제공합니다.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>주요 기능</h2>

        <h3>🎯 미션 관리</h3>
        <ul>
          <li>부모가 자녀별 맞춤 미션 생성</li>
          <li>숙제, 집안일, 독서 등 다양한 미션 템플릿</li>
          <li>요일별 반복 설정 및 마감시간 관리</li>
        </ul>

        <h3>📝 미션 수행</h3>
        <ul>
          <li>자녀가 미션 완료 후 체크 및 증빙 사진 업로드</li>
          <li>부모의 실시간 승인/반려 시스템</li>
          <li>투명한 피드백 및 코멘트 기능</li>
        </ul>

        <h3>💰 용돈 정산</h3>
        <ul>
          <li>주간 미션 완료율에 따른 자동 용돈 계산</li>
          <li>가중치, 보너스, 벌점 시스템</li>
          <li>1도토리 = 1원 포인트 시스템</li>
        </ul>

        <h3>📊 진도 관리</h3>
        <ul>
          <li>주간/월간 미션 완료 통계</li>
          <li>자녀별 성취도 그래프</li>
          <li>연속 달성일수 및 뱃지 시스템</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>서비스 특징</h2>
        <ul>
          <li><strong>모바일 최적화:</strong> 스마트폰에서 쉽게 사용할 수 있는 직관적인 UI</li>
          <li><strong>가족 중심:</strong> 부모 1명, 자녀 최대 5명까지 하나의 가족 계정으로 관리</li>
          <li><strong>안전한 데이터:</strong> 개인정보 최소 수집 및 자동 데이터 정리</li>
          <li><strong>실시간 알림:</strong> Firebase를 통한 즉시 알림 (웹/안드로이드 지원)</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>교육적 가치</h2>
        <ul>
          <li><strong>생활습관 형성:</strong> 규칙적인 미션 수행을 통한 좋은 습관 만들기</li>
          <li><strong>책임감 개발:</strong> 약속한 미션을 끝까지 완수하는 자세</li>
          <li><strong>금융 교육:</strong> 노력에 대한 정당한 보상과 돈의 가치 이해</li>
          <li><strong>가족 소통:</strong> 미션을 매개로 한 부모-자녀 간 긍정적 상호작용</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>대상 사용자</h2>
        <ul>
          <li><strong>부모:</strong> 자녀 교육에 관심이 많은 가정</li>
          <li><strong>자녀:</strong> 초등학생 연령대 (7~13세)</li>
          <li><strong>활용 상황:</strong> 체계적인 용돈 관리를 원하는 가족</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>서비스 정보</h2>
        <ul>
          <li><strong>서비스명:</strong> 도토리 저금통 (Acorn Bank)</li>
          <li><strong>버전:</strong> 1.0.0</li>
          <li><strong>지원 플랫폼:</strong> 웹 브라우저, 안드로이드</li>
          <li><strong>언어:</strong> 한국어</li>
          <li><strong>요금:</strong> 무료 (광고 지원)</li>
        </ul>
      </section>

      <section>
        <h2>문의 및 지원</h2>
        <p>서비스 이용 중 문제가 발생하거나 궁금한 사항이 있으시면 언제든지 연락해 주세요.</p>
        <ul>
          <li><strong>이메일:</strong> <a href="mailto:myid9734+acornban@gmail.com">myid9734+acornban@gmail.com</a></li>
          <li><strong>운영시간:</strong> 평일 09:00 - 18:00</li>
        </ul>
      </section>
    </div>
  );
};

export default About;